import React, { useCallback, useMemo } from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { splitIntoChunks } from 'app/components/swipeableViews/splitArrayIntoChunks';
import isInvalidViewData from 'app/components/swipeableViews/isInvalidViewData';
import StaticNewsList from 'app/components/topNewsModule/subNews/NewsView';
export default function SwipeableNewsList(_ref) {
  let {
    newsList,
    newsPerView,
    updateTrackingData
  } = _ref;
  const viewData = useMemo(() => {
    return splitIntoChunks(newsList, newsPerView);
  }, [newsList, newsPerView]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    if (isInvalidViewData(viewData, index)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(StaticNewsList, {
      key: "news-".concat(newsPerView, "-").concat(index),
      news: viewData[index],
      listLength: newsPerView,
      pageIndex: index
    });
  }, [newsPerView, viewData]);
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: updateTrackingData,
    stepCount: viewData.length,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableNewsList",
    "data-sentry-source-file": "SwipeableNewsList.tsx"
  });
}